import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { StartupInvestorMonthlyInvest } from 'src/app/core/domain';
import { IGlobalSettings } from 'src/app/core/domain/settings.model';
import { getGlobalSettings } from 'src/app/core/state/global';
import { createSlug } from '../../utils/common-methods';

@Component({
  selector: 'app-startup-investor-monthly-investment',
  templateUrl: './startup-investor-monthly-investment.component.html',
  styleUrls: ['./startup-investor-monthly-investment.component.scss']
})
export class StartupInvestorMonthlyInvestmentComponent implements OnInit, OnChanges {

  @Input() title: string;
  @Input() data: StartupInvestorMonthlyInvest[];

  public globalSettings$: Observable<IGlobalSettings>;
  public avatar = '';
  public s3LogoUrl: string = '';
  public globalSettings: IGlobalSettings;
  private destroyed$: Subject<void> = new Subject();

  public updatedList: StartupInvestorMonthlyInvest[];

  constructor(private readonly store: Store) { }

  ngOnInit(): void {
    this.globalSettings$ = this.store.pipe(select(getGlobalSettings));

    this.globalSettings$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      if (res) { this.globalSettings = res; this.createS3LogoUrl(); }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getUpdatedData();
  }

  getUpdatedData() {
    if (this.data && this.data.length > 0) {
      this.updatedList = this.data.map((row: StartupInvestorMonthlyInvest) => {
        this.avatar = row.startup.companyLogo;
        this.createS3LogoUrl();
        const profilePageUrl =`/startups/profile/` + `${row.startup.uuid}/${createSlug(row.startup.companyName)}`;
        return {
          ...row,
          startup: {
            companyName: row.startup.companyName,
            companyLogo: this.s3LogoUrl,
            profilePageUrl: profilePageUrl,
            uuid: row.startup.uuid
          }
        }
      })
    }
  }

  createS3LogoUrl = () => {
    if (this.globalSettings?.s3Url && this.avatar) {
      this.s3LogoUrl = this.globalSettings.imgKitUrl + this.avatar;
    } else {
      this.s3LogoUrl = '';
    }
  }

}
